<template>
  <div v-loading="loading" class="business-brands_container">
    <h2 class="business-brands_container_top">
      <div style="display: flex;align-items: center;justify-content: center;">
        <el-date-picker v-model="search.month" value-format="yyyy-MM-dd" type="month" :clearable="false" />
        {{ search.month|parseTime('{y}年{m}月') }}已定商单品牌
      </div>
      <ul>
        <li v-for="category in trades" :key="category.label" :class="{active:category.value===search.trade}"
            @click="search.trade=category.value">
          {{ category.label }}
        </li>
      </ul>
      <div class="tool">
        <export-by-page module="BUSINESS_BRANDS" :custom-search="getParams" :search="{}" txt="下载《已定商单品牌》表格"
                        is-text />
      </div>
    </h2>
    <el-empty v-if="!collection||collection.length<1" />
    <div v-else class="business-brands_container__main">
      <div v-for="(brand,brand_i) in collection" :key="brand_i" class="brand">
        <span v-if="brand.is_newer" class="newer">new</span>
        <span>{{ brand_i + 1 }}. {{ brand.brand_name }}</span>
        <span>{{ brand.trade }}——{{brand.sale_name||''}}</span>
      </div>
    </div>
    <div style="margin-top: 20px;text-align: center;">
      <span style="color: #999;">合计: {{ collection.length }} 个</span>
    </div>
  </div>
</template>
<script>
import { brandDataMonth, brandDataMonthTrades } from '@/api/ad_system'
import moment from 'moment/moment'
import ExportByPage from '@/components/export/ByPage/index.vue'

export default {
  name: 'BusinessBrandIndex',
  components: { ExportByPage },
  data() {
    return {
      collection: [],
      trades: [],
      search: {
        month: moment().startOf('month').format('YYYY-MM-DD'),
        trade: ''
      },
      loading: false
    }
  },
  watch: {
    'search.trade': {
      deep: true,
      handler() {
        this.getData()
      }
    },
    'search.month': {
      deep: true,
      handler() {
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init: function() {
      this.search.trade = ''
      this.getTrades()
      this.getData()
    },
    getYM: function() {
      const year = moment(this.search.month).format('YYYY')
      const month = moment(this.search.month).format('MM')
      return { year, month }
    },
    getTrades: async function() {
      const { data } = await brandDataMonthTrades(this.getYM())
      const trades = []
      for (let i = 0; i < data.length; i++) {
        trades.push({ value: data[i], label: data[i], children: [] })
      }
      this.trades = trades
      this.trades.unshift({ value: '', label: '全行业', children: [] })
    },
    getParams: function() {
      const params = this.getYM()
      params.trade = this.search.trade
      return params
    },
    getData: async function() {
      this.loading = true
      const { list } = await brandDataMonth(this.getParams())
      this.collection = list || []
      setTimeout(() => {
        this.loading = false
      }, 200)
    }
  }
}
</script>
<style lang="scss">
$--color-primary: #8b0000;

.BusinessBrands_main-content {
  margin: 12px !important;
  padding: 0 !important;
  background: #ffffff;
  border-radius: 20px;
}


.business-brands_container {
  height: calc(100vh - 100px - 45px);
  font-family: 'PH Medium';
  padding: 0 12px 12px 12px !important;

  &__main {
    padding: 12px 24px;
    max-height: calc(100% - 245px);
    overflow-y: auto;
  }

  .business-brands_container_top {
    text-align: center;
    padding: 1.66vw 0 3.33vw 0;
    font-size: 1.1vw;
    margin: 0;
    position: relative;
    background-image: url("~@/assets/imgs/emphasis-products-bg.png");
    background-size: 100% auto;

    .tool {
      position: absolute;
      right: 1vw;
      top: 36px;
    }

    ul {
      position: absolute;
      bottom: 0;
      width: 100%;
      justify-content: center;
      display: flex;
      font-size: 0.729vw;

      li {
        color: #666;
        padding: 0.625vw 1.04vw;
        cursor: pointer;
      }

      li.active {
        background: #fff;
        border-radius: 12px 12px 0 0;
        color: #1a1a1a;
      }
    }
  }

  .search {
    //display: flex;
    //justify-content: end;
    padding: 24px 12px;
    margin-bottom: 48px;
    position: relative;

    .search_line {
      position: absolute;
      bottom: 0;
      left: 35%;
      width: 30%;
      border-bottom: 1px solid #f9f9f9;
    }
  }

  .business-brands_container__main {
    margin-top: 3vw;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 1vw;

    .brand {
      position: relative;
      border: 1px dashed #8b000030;
      background: linear-gradient(-270deg, hsla(0,0%,100%,.6) -17%, hsla(0, 0%, 100%, .7) 31%, hsla(0, 0%, 100%, .14) 95%);
      padding: 8px 12px;
      border-radius: 100px;
      font-size: 0.72vw;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .newer {
        padding: 0.05vw 0.3vw;
        height: 15px;
        border-radius: 4px;
        display: flex;
        font-size: 0.6vw;
        align-items: center;
        justify-content: center;
        background-color: #ff5722;
        color: #fff;
        line-height: 0;
        position: absolute;
        top: -0.625vw;
        margin-right: 6px;
      }

      i {
        font-size: 21px;
        top: 5px;
        position: absolute;
        right: 12px;
        transition: transform 0.3s;
        transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
        transform: translate3d(-40px, 1.5em, 0);
      }

      span:first-child {
        font-weight: 550;
        //font-weight: bold;
      }

      span:last-child {
        color: #666;
      }
    }

    .brand:hover {
      background: #ff3176;
      border-color: #ff3176;
      color: #fff;

      span:last-child {
        color: #fff;
      }
    }
  }

  .el-radio__label {
    font-size: 12px;
  }

  .el-date-editor {
    width: 29px !important;
    height: 24px !important;

    .el-input__inner {
      display: none;
    }

    .el-icon-date {
      font-size: 18px;
      line-height: 18px;
      margin-bottom: 2px;
      margin-right: 4px;
      cursor: pointer;
      color: #fe346e;
    }
  }
}
</style>
